"use strict";

exports.__esModule = true;
exports.CancelBtn = CancelBtn;
exports.DoneBtn = DoneBtn;
exports.LoadingSpinner = LoadingSpinner;
exports.PauseResumeButton = PauseResumeButton;
exports.ProgressBarComplete = ProgressBarComplete;
exports.ProgressBarError = ProgressBarError;
exports.ProgressBarProcessing = ProgressBarProcessing;
exports.ProgressBarUploading = ProgressBarUploading;
exports.ProgressDetails = ProgressDetails;
exports.RetryBtn = RetryBtn;
exports.UploadBtn = UploadBtn;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
var _prettierBytes = _interopRequireDefault(require("@transloadit/prettier-bytes"));
var _prettyETA = _interopRequireDefault(require("@uppy/utils/lib/prettyETA"));
var _StatusBarStates = _interopRequireDefault(require("./StatusBarStates.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var DOT = "\xB7";
var renderDot = function renderDot() {
  return " ".concat(DOT, " ");
};
function UploadBtn(props) {
  var newFiles = props.newFiles,
    isUploadStarted = props.isUploadStarted,
    recoveredState = props.recoveredState,
    i18n = props.i18n,
    uploadState = props.uploadState,
    isSomeGhost = props.isSomeGhost,
    startUpload = props.startUpload;
  var uploadBtnClassNames = (0, _classnames.default)('uppy-u-reset', 'uppy-c-btn', 'uppy-StatusBar-actionBtn', 'uppy-StatusBar-actionBtn--upload', {
    'uppy-c-btn-primary': uploadState === _StatusBarStates.default.STATE_WAITING
  }, {
    'uppy-StatusBar-actionBtn--disabled': isSomeGhost
  });
  var uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n('uploadXNewFiles', {
    smart_count: newFiles
  }) : i18n('uploadXFiles', {
    smart_count: newFiles
  });
  return (0, _preact.h)("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n('uploadXFiles', {
      smart_count: newFiles
    }),
    onClick: startUpload,
    disabled: isSomeGhost,
    "data-uppy-super-focusable": true
  }, uploadBtnText);
}
function RetryBtn(props) {
  var i18n = props.i18n,
    uppy = props.uppy;
  return (0, _preact.h)("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
    "aria-label": i18n('retryUpload'),
    onClick: function onClick() {
      return uppy.retryAll().catch(function () {
        /* Error reported and handled via an event */
      });
    },
    "data-uppy-super-focusable": true,
    "data-cy": "retry"
  }, (0, _preact.h)("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "8",
    height: "10",
    viewBox: "0 0 8 10"
  }, (0, _preact.h)("path", {
    d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
  })), i18n('retry'));
}
function CancelBtn(props) {
  var i18n = props.i18n,
    uppy = props.uppy;
  return (0, _preact.h)("button", {
    type: "button",
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    title: i18n('cancel'),
    "aria-label": i18n('cancel'),
    onClick: function onClick() {
      return uppy.cancelAll();
    },
    "data-cy": "cancel",
    "data-uppy-super-focusable": true
  }, (0, _preact.h)("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, (0, _preact.h)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _preact.h)("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), (0, _preact.h)("path", {
    fill: "#FFF",
    d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
  }))));
}
function PauseResumeButton(props) {
  var isAllPaused = props.isAllPaused,
    i18n = props.i18n,
    isAllComplete = props.isAllComplete,
    resumableUploads = props.resumableUploads,
    uppy = props.uppy;
  var title = isAllPaused ? i18n('resume') : i18n('pause');
  function togglePauseResume() {
    if (isAllComplete) return;
    if (!resumableUploads) {
      uppy.cancelAll();
      return;
    }
    if (isAllPaused) {
      uppy.resumeAll();
      return;
    }
    uppy.pauseAll();
  }
  return (0, _preact.h)("button", {
    title: title,
    "aria-label": title,
    className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
    type: "button",
    onClick: togglePauseResume,
    "data-cy": "togglePauseResume",
    "data-uppy-super-focusable": true
  }, (0, _preact.h)("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-c-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, (0, _preact.h)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _preact.h)("circle", {
    fill: "#888",
    cx: "8",
    cy: "8",
    r: "8"
  }), (0, _preact.h)("path", {
    fill: "#FFF",
    d: isAllPaused ? 'M6 4.25L11.5 8 6 11.75z' : 'M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z'
  }))));
}
function DoneBtn(props) {
  var i18n = props.i18n,
    doneButtonHandler = props.doneButtonHandler;
  return (0, _preact.h)("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
    onClick: doneButtonHandler,
    "data-uppy-super-focusable": true
  }, i18n('done'));
}
function LoadingSpinner() {
  return (0, _preact.h)("svg", {
    className: "uppy-StatusBar-spinner",
    "aria-hidden": "true",
    focusable: "false",
    width: "14",
    height: "14"
  }, (0, _preact.h)("path", {
    d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
    fillRule: "evenodd"
  }));
}
function ProgressBarProcessing(props) {
  var progress = props.progress;
  var value = progress.value,
    mode = progress.mode,
    message = progress.message;
  var dot = "\xB7";
  return (0, _preact.h)("div", {
    className: "uppy-StatusBar-content"
  }, (0, _preact.h)(LoadingSpinner, null), mode === 'determinate' ? "".concat(Math.round(value * 100), "% ").concat(dot, " ") : '', message);
}
function ProgressDetails(props) {
  var numUploads = props.numUploads,
    complete = props.complete,
    totalUploadedSize = props.totalUploadedSize,
    totalSize = props.totalSize,
    totalETA = props.totalETA,
    i18n = props.i18n;
  var ifShowFilesUploadedOfTotal = numUploads > 1;
  return (0, _preact.h)("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, ifShowFilesUploadedOfTotal && i18n('filesUploadedOfTotal', {
    complete: complete,
    smart_count: numUploads
  }), (0, _preact.h)("span", {
    className: "uppy-StatusBar-additionalInfo"
  }, ifShowFilesUploadedOfTotal && renderDot(), i18n('dataUploadedOfTotal', {
    complete: (0, _prettierBytes.default)(totalUploadedSize),
    total: (0, _prettierBytes.default)(totalSize)
  }), renderDot(), i18n('xTimeLeft', {
    time: (0, _prettyETA.default)(totalETA)
  })));
}
function FileUploadCount(props) {
  var i18n = props.i18n,
    complete = props.complete,
    numUploads = props.numUploads;
  return (0, _preact.h)("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, i18n('filesUploadedOfTotal', {
    complete: complete,
    smart_count: numUploads
  }));
}
function UploadNewlyAddedFiles(props) {
  var i18n = props.i18n,
    newFiles = props.newFiles,
    startUpload = props.startUpload;
  var uploadBtnClassNames = (0, _classnames.default)('uppy-u-reset', 'uppy-c-btn', 'uppy-StatusBar-actionBtn', 'uppy-StatusBar-actionBtn--uploadNewlyAdded');
  return (0, _preact.h)("div", {
    className: "uppy-StatusBar-statusSecondary"
  }, (0, _preact.h)("div", {
    className: "uppy-StatusBar-statusSecondaryHint"
  }, i18n('xMoreFilesAdded', {
    smart_count: newFiles
  })), (0, _preact.h)("button", {
    type: "button",
    className: uploadBtnClassNames,
    "aria-label": i18n('uploadXFiles', {
      smart_count: newFiles
    }),
    onClick: startUpload
  }, i18n('upload')));
}
function ProgressBarUploading(props) {
  var i18n = props.i18n,
    supportsUploadProgress = props.supportsUploadProgress,
    totalProgress = props.totalProgress,
    showProgressDetails = props.showProgressDetails,
    isUploadStarted = props.isUploadStarted,
    isAllComplete = props.isAllComplete,
    isAllPaused = props.isAllPaused,
    newFiles = props.newFiles,
    numUploads = props.numUploads,
    complete = props.complete,
    totalUploadedSize = props.totalUploadedSize,
    totalSize = props.totalSize,
    totalETA = props.totalETA,
    startUpload = props.startUpload;
  var showUploadNewlyAddedFiles = newFiles && isUploadStarted;
  if (!isUploadStarted || isAllComplete) {
    return null;
  }
  var title = isAllPaused ? i18n('paused') : i18n('uploading');
  function renderProgressDetails() {
    if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
      if (supportsUploadProgress) {
        return (0, _preact.h)(ProgressDetails, {
          numUploads: numUploads,
          complete: complete,
          totalUploadedSize: totalUploadedSize,
          totalSize: totalSize,
          totalETA: totalETA,
          i18n: i18n
        });
      }
      return (0, _preact.h)(FileUploadCount, {
        i18n: i18n,
        complete: complete,
        numUploads: numUploads
      });
    }
    return null;
  }
  return (0, _preact.h)("div", {
    className: "uppy-StatusBar-content",
    "aria-label": title,
    title: title
  }, !isAllPaused ? (0, _preact.h)(LoadingSpinner, null) : null, (0, _preact.h)("div", {
    className: "uppy-StatusBar-status"
  }, (0, _preact.h)("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, supportsUploadProgress ? "".concat(title, ": ").concat(totalProgress, "%") : title), renderProgressDetails(), showUploadNewlyAddedFiles ? (0, _preact.h)(UploadNewlyAddedFiles, {
    i18n: i18n,
    newFiles: newFiles,
    startUpload: startUpload
  }) : null));
}
function ProgressBarComplete(props) {
  var i18n = props.i18n;
  return (0, _preact.h)("div", {
    className: "uppy-StatusBar-content",
    role: "status",
    title: i18n('complete')
  }, (0, _preact.h)("div", {
    className: "uppy-StatusBar-status"
  }, (0, _preact.h)("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, (0, _preact.h)("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "15",
    height: "11",
    viewBox: "0 0 15 11"
  }, (0, _preact.h)("path", {
    d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
  })), i18n('complete'))));
}
function ProgressBarError(props) {
  var error = props.error,
    i18n = props.i18n,
    complete = props.complete,
    numUploads = props.numUploads;
  function displayErrorAlert() {
    var errorMessage = "".concat(i18n('uploadFailed'), " \n\n ").concat(error);
    // eslint-disable-next-line no-alert
    alert(errorMessage); // TODO: move to custom alert implementation
  }
  return (0, _preact.h)("div", {
    className: "uppy-StatusBar-content",
    title: i18n('uploadFailed')
  }, (0, _preact.h)("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: "uppy-StatusBar-statusIndicator uppy-c-icon",
    width: "11",
    height: "11",
    viewBox: "0 0 11 11"
  }, (0, _preact.h)("path", {
    d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
  })), (0, _preact.h)("div", {
    className: "uppy-StatusBar-status"
  }, (0, _preact.h)("div", {
    className: "uppy-StatusBar-statusPrimary"
  }, i18n('uploadFailed'), (0, _preact.h)("button", {
    className: "uppy-u-reset uppy-StatusBar-details",
    "aria-label": i18n('showErrorDetails'),
    "data-microtip-position": "top-right",
    "data-microtip-size": "medium",
    onClick: displayErrorAlert,
    type: "button"
  }, "?")), (0, _preact.h)(FileUploadCount, {
    i18n: i18n,
    complete: complete,
    numUploads: numUploads
  })));
}